"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.heading.chat': 'Zacznij rozmawiać ze swoim asystentem AI',
    'chat.heading.ask': 'Zadaj swoje pytanie',
};
